import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import AddPersonDataType from "./AddPersonDataType"
import EditPersonDataType from "./EditPersonDataType"
import PersonDataTypeList from "./PersonDataTypeList"

 class Index extends Component {
   constructor(props) {
     super(props);
     this.state = {
       routeStatus: 0,
       dataValue: {},
     };
   }

   changeStatus = (type) => {
     this.setState({
       routeStatus: type,
     });
   };

   changeStatusWithStatusValue = (type, dataValue) => {
     this.setState({
       routeStatus: type,
       dataValue,
     });
   };

   render() {
     const { routeStatus, dataValue } = this.state;
     return (
       <div className="wrapper position-relative">
         {routeStatus == 0 && (
           <PersonDataTypeList
             changeStatusWithStatusValue={this.changeStatusWithStatusValue}
           />
         )}

         {routeStatus == 1 && <AddPersonDataType changeRouteStatus={this.changeStatus} />}

         {routeStatus == 2 && (
           <EditPersonDataType changeRouteStatus={this.changeStatus} item={dataValue} />
         )}
       </div>
     );
   }
 }
export default (withRouter(Index));